"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'payment.validation.providerRequired': 'El proveedor de pagos es requerido',
    'payment.validation.amountRequired': 'Se requiere una cantidad válida',
    'payment.validation.currencyRequired': 'La moneda es requerida',
};
